export default {
  EditAssumptions: {
    Title            : 'Edit Assumptions',
    CancelTitle      : 'Cancel',
    InterestRateRerun: 'Rerun Interest Rate',
    LiquidityRerun   : 'Rerun Liquidity',
    RerunModal       : {
      Title          : 'We are rerunning the tests',
      Subtitle       : 'Hang on a second, we are almost there',
      SuccessTitle   : 'We have rerun the tests successfully',
      SuccessSubtitle: 'Check out the new metrics in '
    },
    SaveAssumptionsModal: {
      Title      : 'Select a name for the Risk Analysis',
      Placeholder: 'My Analysis Name',
      Cancel     : 'Cancel',
      Save       : 'Save',
      Duplicate  : 'An analysis with this name already exists'
    },
    Tabs: {
      LoanAssumptions: {
        Title                  : 'Loan Assumptions',
        Slug                   : 'loan-assumptions',
        LoansReinvestmentSpread: 'Loans Reinvestment Spread'
      },
      DepositAssumptions: {
        Title                     : 'Deposit Assumptions',
        Slug                      : 'deposit-assumptions',
        DepositsReinvestmentSpread: 'Deposits Reinvestment Spread',
        DepositAverageLife        : 'Deposit Average Life',
        DepositDecayRate          : 'Deposit Decay Rate',
        DepositUpBeta             : 'Deposit Up β',
        DepositDownBeta           : 'Deposit Down β'
      },
      GeneralAssumptions: {
        Title: 'General Assumptions',
        Slug : 'general-assumptions'
      },
      LiquidityAssumptions: {
        Title: 'Liquidity Assumptions',
        Slug : 'liquidity-assumptions'
      },
      Button: {
        SaveAssumptions: 'Save Assumptions'
      }
    }
  }
}
